module.exports = __webpack_public_path__ + "static/media/laptop.0e9e57fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/laptop.svg
// module id = 1300
// module chunks = 0